export default function SchematicSectionController(
  $q,
  $scope,
  loaderService,
  userService,
  ssDialogService,
  editSchematicDialog,
  uploadSchematicsDialog
) {
  const vm = this;

  vm.handleAdd = _handleAdd;
  vm.handleAddMultiple = _handleAddMultiple;

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function _handleAdd($event) {
    ssDialogService.dialogs.bcp.editSchematicDialog = ssDialogService.alert(
      editSchematicDialog.getOptions($event, {
        customerId: vm.customerId,
        assessmentId: vm.assessmentId,
        schematicSectionId: vm.sectionId,
        schematic: {
          assessmentId: vm.assessmentId,
          assessmentSchematicId: -1,
          schematicSectionId: vm.sectionId,
        },
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editSchematicDialog);
  }

  function _handleAddMultiple($event) {
    ssDialogService.dialogs.bcp.uploadSchematicsDialog = ssDialogService.alert(
      uploadSchematicsDialog.getOptions($event, {
        customerId: vm.customerId,
        assessmentId: vm.assessmentId,
        schematicSectionId: vm.sectionId,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.uploadSchematicsDialog);
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    _initEventListeners();
    _initPermissions();
  }

  function _initEventListeners() {
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }
}

SchematicSectionController.$inject = [
  '$q',
  '$scope',
  'loaderService',
  'userService',
  'ssDialogService',
  'editSchematicDialog',
  'uploadSchematicsDialog',
];
